import styled from 'styled-components';
import { Link } from '@material-ui/core';

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
`;
